function pickMaterial(a){
  const sc={bambus:0,egyptisk:0,hor:0,silke:0};
  if(a.gender==="kvinde"&&a.age==="45-59"){sc.bambus+=1;}
  (a.challenges||[]).forEach(c=>{
    if(c==="hot"||c==="hedeture"){sc.bambus+=2;sc.hor+=2;}
    if(c==="cold"){sc.silke+=2;sc.egyptisk+=1;}
    if(c==="skin"){sc.silke+=2;sc.bambus+=1;}
    if(c==="hair"){sc.silke+=3;}
    if(c==="allergy"){sc.bambus+=2;sc.silke+=1;}
    if(c==="restless"){sc.bambus+=1;sc.silke+=1;}
  });
  if(a.partner==="warm"){sc.bambus+=1;sc.hor+=1;}
  if(a.partner==="cold"){sc.silke+=1;sc.egyptisk+=1;}
  if(a.feel==="cool"){sc.bambus+=3;sc.hor+=1;}
  if(a.feel==="hotel"){sc.egyptisk+=3;sc.silke+=1;}
  if(a.feel==="skin"){sc.silke+=3;}
  if(a.feel==="natural"){sc.hor+=3;}
  const order=["bambus","egyptisk","hor","silke"];let best=order[0];order.forEach(m=>{if(sc[m]>sc[best])best=m;});return best;
}

const CH={hot:"du får det varmt om natten",hedeture:"du oplever hedeture",cold:"du fryser nemt",skin:"du vil skåne sart eller allergisk hud",hair:"du vil undgå tørt og krøllet hår",allergy:"du vil mindske allergener og støvmider",restless:"du vil sove mere uforstyrret"};
const BEN={bambus:"bambus sengetøj er naturligt temperaturregulerende, åndbart og et blødt, allergivenligt alternativ til bomuld",egyptisk:"egyptisk bomuld er satinvævet af lange fibre - åndbart, fugtabsorberende og silkeblødt med en hotelfølelse, der holder år efter år",hor:"hør er naturligt åndbart og fugtabsorberende, så du sover tørt - køligt om sommeren og lunt om vinteren",silke:"silke er glat og skånsom mod hud og hår, hypoallergen og naturligt temperaturregulerende"};

/* ALDER BRUGT I BEGRUNDELSEN, tilfoejet 31-08-2026.

   Spoergsmaalet om koen og alder blev stillet for at goere anbefalingen
   personlig, men svaret endte kun som en maerkat ("Kvinde · 45-59 aar") plus
   eet point til bambus. Kunden kunne ikke SE at svaret blev brugt.

   Teksterne er destilleret af guidens egne indsigtsafsnit om soevn gennem livet,
   som stod i nw-sg-3.js og aldrig naaede laengere end til et udfoldeligt panel.
   De fire aldersteksters er koensneutrale.

   OVERGANGSALDER naevnes kun naar ALLE tre ting er sande: koen er kvinde, alder
   er 45-59, OG kunden har selv valgt hedeture som noget sengetoejet skal hjaelpe
   med. Uden det sidste ville vi paastaa noget om hendes krop, hun ikke har sagt.
   Maend faar slet ikke muligheden, se optionsFor i nw-sg-3.js. */
const ALDER={
  "18-29":"I din aldersgruppe er åndbarhed typisk det, der betyder mest, fordi kroppen ofte er varm om natten.",
  "30-44":"Midt i livet holder en travl hverdag ofte kropstemperaturen oppe om aftenen, og der gør et materiale, som leder varme og fugt væk, en mærkbar forskel.",
  "45-59":"Fra midten af fyrrerne bliver søvnen mere følsom over for temperatursvingninger, og netop der betyder et temperaturregulerende materiale mest.",
  "60+":"Med årene bliver søvnen lettere og mere følsom over for temperatur, så en stabil, kølig seng giver færre opvågninger."
};
function alderTekst(a){
  try{
    if(a.gender==="kvinde" && a.age==="45-59" && (a.challenges||[]).indexOf("hedeture")>=0){
      return "Hormonelle udsving i overgangsalderen giver hedeture og svedige opvågninger, og netop der gør et fugttransporterende, temperaturregulerende materiale den største forskel.";
    }
    return ALDER[a.age]||"";
  }catch(e){ return ""; }
}

function joinDa(a){if(a.length===1)return a[0];if(a.length===2)return a[0]+" og "+a[1];return a.slice(0,-1).join(", ")+" og "+a[a.length-1];}
function tailoredWhy(mat,a){
  const chs=(a.challenges||[]).map(c=>CH[c]).filter(Boolean);
  let lead = chs.length ? `Du fortæller, at ${joinDa(chs)}. ` : `Ud fra dine svar `;
  let s=lead+`Derfor anbefaler vi ${materials[mat].name.toLowerCase()}: <b>${BEN[mat]}</b>.`;
  const at=alderTekst(a);
  if(at){ s+=" "+at; }
  if(a.sleepers==="par"){
    const u=userTemp(a),p=a.partner;
    if((u==="warm"&&p==="cold")||(u==="cold"&&p==="warm")) s+=" I sover forskelligt, så vi har sat jer op med delt sengetøj - hver sit sæt på samme madras.";
    else s+=" Materialet passer jer begge.";
  }
  return s;
}
function metaLine(a){
  const g={kvinde:"Kvinde",mand:"Mand",andet:""}[a.gender]||"";
  const parts=[g,a.age?a.age+" år":"",a.sleepers==="par"?"til jer begge":""].filter(Boolean);
  return "Skræddersyet"+(parts.length?" · "+parts.join(" · "):" til din søvn");
}
function resolveSize(mat,sizeId){const list=materials[mat].sizes;if(list.find(s=>s.v===sizeId))return sizeId;if(sizeId==="240×220")return "200×220";return list[0].v;}
function sizeObj(){return materials[chosen.mat].sizes.find(s=>s.v===chosen.size)||materials[chosen.mat].sizes[0];}
function defaultColorIdx(mat,tone){const cs=materials[mat].colors;const i=cs.findIndex(c=>c.tone===tone);return i>=0?i:0;}
function matchColor(list,name,tone){let i=list.findIndex(c=>c.name.toLowerCase()===(name||"").toLowerCase());if(i>=0)return i;i=list.findIndex(c=>c.tone===tone);return i>=0?i:0;}

let showAll=false;
function goToResult(){
  go("loading");
  /* Forsinkelsen var 1700 ms hardkodet tomgang. Der er noget om at vise arbejde,
     saa resultatet foeles gennemtaenkt, men 1,7 sekunders bevidst venten paa
     mobil betalt trafik er dyrt. Sat til 900 ms. Boer maales naar
     instrumenteringen er tilsluttet. */
  setTimeout(()=>{
    chosen.mat=pickMaterial(answers);
    chosen.color=defaultColorIdx(chosen.mat,answers.tone);
    chosen.rec=chosen.color;
    showAll=false;
    chosen.hero=0;
    const u=userTemp(answers);
    chosen.split = answers.sleepers==="par" && ((u==="warm"&&answers.partner==="cold")||(u==="cold"&&answers.partner==="warm"));
    chosen.size = chosen.split ? resolveSize(chosen.mat,"140×200") : resolveSize(chosen.mat, answers.size||"140×200");
    chosen.qty = chosen.split ? 2 : (answers.qty||(answers.sleepers==="par"?2:1));
    const setName=materials[chosen.mat].colors[chosen.color].name, setTone=materials[chosen.mat].colors[chosen.color].tone;
    chosen.lagen={on:true,ci:matchColor(lagenColors,setName,setTone),size:(answers.bed||"90×200"),qty:1,type:"box"};
    chosen.pb={qty:0,ci:matchColor(pudeColors,setName,setTone),size:"60×63"};
    chosen.pude={qty:0};
    var _dr=dyneRec(chosen.mat,answers);chosen.dyne={on:false,opt:_dr,rec:_dr};
    chosen.simple={plaid:false,vaskemiddel:true,vaskepose:false};
    exp.lagen=false;exp.pb=false;exp.dyne=false;
    renderResult();go("result");
  },900);
}

function lagenUnit(){const s=lagenSizes.find(s=>s.v===chosen.lagen.size)||lagenSizes[0];return chosen.lagen.type==="kuvert"?s.kuvert:s.box;}
function pbUnit(){return (pbSizes.find(s=>s.v===chosen.pb.size)||pbSizes[0]).price;}
function lagenTotal(){return chosen.lagen.on?lagenUnit()*chosen.lagen.qty:0;}
function changeQty(d){chosen.qty=Math.max(1,Math.min(9,chosen.qty+d));document.getElementById("qtyval").textContent=chosen.qty;updateTotal();}